module.exports = __webpack_public_path__ + "media/icons/high-speed-train-9b0f2df6.svg";